import { AxiosInstance, InternalAxiosRequestConfig } from 'axios';

export default function applyInterceptRequest(api: AxiosInstance) {
  api.interceptors.request.use(
    async (config: InternalAxiosRequestConfig) => {
      if (['post', 'delete'].includes(config.method!) && !config.baseURL?.startsWith('https://orlov')) {
        const { data } = await api.get('api/v1/csrf/');
        config.headers['X_CSRFTOKEN'] = data.token;
      }
      return config;
    },
    error => Promise.reject(error)
  );
}
